import threedocean from './3docean.json'
import audiojungle from './audiojungle.json'
import codecanyon from './codecanyon.json'
import graphicriver from './graphicriver.json'
import photodune from './photodune.json'
import themeforest from './experimentalThemeforest.json'
import videohive from './videohive.json'

import { Site } from '../../../common/constants/siteList'

export default {
  [Site.threedocean]: threedocean,
  [Site.audiojungle]: audiojungle,
  [Site.codecanyon]: codecanyon,
  [Site.graphicriver]: graphicriver,
  [Site.photodune]: photodune,
  [Site.themeforest]: themeforest,
  [Site.videohive]: videohive
}
